export default ({ app }, inject) => {
  inject('currency', (value) => app.i18n.n(value, 'currency'))
}
